// extracted by mini-css-extract-plugin
export var activeLink = "footer-module--activeLink--f17bc";
export var credits = "footer-module--credits--42c98";
export var description = "footer-module--description--c9e0d";
export var divider = "footer-module--divider--7c7e0";
export var footer = "footer-module--footer--02543";
export var inner = "footer-module--inner--2b866";
export var link = "footer-module--link--89f6d";
export var links = "footer-module--links--043ff";
export var logo = "footer-module--logo--c7477";
export var rowBottom = "footer-module--rowBottom--89417";
export var rowContent = "footer-module--rowContent--45e2c";
export var rowLogo = "footer-module--rowLogo--a58bb";
export var social = "footer-module--social--f0e57";
export var socialButton = "footer-module--socialButton--daaf1";
export var socialIcon = "footer-module--socialIcon--acd59";